import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { DomainsAndMailboxDashboard } from "@/components/domains-mailboxes/DomainsAndMailboxDashboard"

const MailboxManagement = () => {
  return (
    <NewAppLayout fullWidth>
      <DomainsAndMailboxDashboard />
    </NewAppLayout>
  )
}

export default MailboxManagement
